import { fmtDateTime } from '../../shared/format';
import { Empty } from '../../shared/ui';
import { actionLabel } from '../labels';
import type { AuditEntry } from '../types';
import { JsonDetail } from './JsonDetail';

/** Rastro del registro: quién de ECINSA tocó qué y qué dejó. */
export function AuditTable({ entries, showTarget = true }: { entries: AuditEntry[]; showTarget?: boolean }): JSX.Element {
  if (entries.length === 0) {
    return <Empty icon="☰">Todavía no hay nada apuntado. Cada cambio que se haga desde el panel quedará aquí.</Empty>;
  }
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Quién</th>
            <th>Acción</th>
            {showTarget ? <th>Sobre</th> : null}
            <th>Detalle</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.id}>
              <td className="nowrap num">{fmtDateTime(e.at)}</td>
              <td className="nowrap">{e.actor}</td>
              <td className="nowrap" title={e.action}>
                {actionLabel(e.action)}
              </td>
              {showTarget ? <td className="mono nowrap">{e.target ?? '—'}</td> : null}
              <td className="detail-cell">
                <JsonDetail value={e.detail} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
